import axios from 'axios';
import { header } from '../components/header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL || 'http://localhost:3021';

class SpecialCollectionService {
  // Get all collections with optional filters
  static async getCollections(params = {}) {
    try {
      const response = await axios.get(`${API_URL}/special-collections`, { 
        ...header(),
        params 
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching collections:', error);
      throw error;
    }
  }

  // Get a specific collection by ID
  static async getCollectionById(id) {
    try {
      const response = await axios.get(`${API_URL}/special-collections/${id}`, header());
      return response.data;
    } catch (error) {
      console.error('Error fetching collection:', error);
      throw error;
    }
  }

  // Create a new collection
  static async createCollection(data) {
    try {
      const response = await axios.post(`${API_URL}/special-collections`, data, header());
      return response.data;
    } catch (error) {
      console.error('Error creating collection:', error);
      throw error;
    }
  }

  // Update a collection
  static async updateCollection(id, data) {
    try {
      const response = await axios.put(`${API_URL}/special-collections/${id}`, data, header());
      return response.data;
    } catch (error) {
      console.error('Error updating collection:', error);
      throw error;
    }
  }

  // Delete a collection
  static async deleteCollection(id) {
    try {
      const response = await axios.delete(`${API_URL}/special-collections/${id}`, header());
      return response.data;
    } catch (error) {
      console.error('Error deleting collection:', error);
      throw error;
    }
  }

  // Add a store to a collection
  static async addStoreToCollection(collectionId, storeData) {
    try {
      const response = await axios.post(
        `${API_URL}/special-collections/${collectionId}/stores`,
        storeData,
        header()
      );
      return response.data;
    } catch (error) {
      console.error('Error adding store to collection:', error);
      throw error;
    }
  }

  // Remove a store from a collection
  static async removeStoreFromCollection(collectionId, storeId) {
    try {
      const response = await axios.delete(
        `${API_URL}/special-collections/${collectionId}/stores/${storeId}`,
        header()
      );
      return response.data;
    } catch (error) {
      console.error('Error removing store from collection:', error);
      throw error;
    }
  }

  // Add a product to a store in a collection
  static async addProductToStore(collectionId, storeId, productData) {
    try {
      const response = await axios.post(
        `${API_URL}/special-collections/${collectionId}/stores/${storeId}/products`,
        productData,
        header()
      );
      return response.data;
    } catch (error) {
      console.error('Error adding product to store:', error);
      throw error;
    }
  }

  // Update a product in a store
  static async updateProduct(collectionId, storeId, productId, updates) {
    try {
      const response = await axios.put(
        `${API_URL}/special-collections/${collectionId}/stores/${storeId}/products/${productId}`,
        updates,
        header()
      );
      return response.data;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  }

  // Update all products for a store (bulk update)
  static async updateStoreProducts(collectionId, storeId, products) {
    try {
      const response = await axios.put(
        `${API_URL}/special-collections/${collectionId}/stores/${storeId}/products`,
        { products },
        header()
      );
      return response.data;
    } catch (error) {
      console.error('Error updating store products:', error);
      throw error;
    }
  }

  // Remove a product from a store
  static async removeProductFromStore(collectionId, storeId, productId) {
    try {
      const response = await axios.delete(
        `${API_URL}/special-collections/${collectionId}/stores/${storeId}/products/${productId}`,
        header()
      );
      return response.data;
    } catch (error) {
      console.error('Error removing product from store:', error);
      throw error;
    }
  }
}

export default SpecialCollectionService;
